import { render, staticRenderFns } from "./contactUs.vue?vue&type=template&id=bdd80c08&scoped=true&"
import script from "./contactUs.vue?vue&type=script&lang=ts&"
export * from "./contactUs.vue?vue&type=script&lang=ts&"
import style0 from "./contactUs.vue?vue&type=style&index=0&id=bdd80c08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd80c08",
  null
  
)

export default component.exports